<template>
	<div>
        <div class="modal-small-toolbar">
            <span>Units</span>
        </div>
        <div class="w-full p-4 mr-2">
            <table class="w-full">
                <thead class="cursor-pointer">
                    <tr>
                        <th></th>
                        <th class="text-center">Floor</th>
                        <th class="text-center">Suite</th>
                        <th class="text-right">Size</th>
                        <th class="text-right">Status</th>
                        <th class="text-center">Last Update</th>
                        <th>Leased Space</th>
                    </tr>
                </thead>
                <paginate name="units" :list="units" :per="perPage" tag="tbody">
                    <tr v-for="unit in paginated('units')" :key="unit.id">
                        <td class="flex items-center justify-center pl-2 pt-4">
                            <div class="flex justify-center items-center w-8 h-8 shadow-md text-xs text-white bg-white border border-gray-300">
                                <input @click="toggleUnit($event, unit.id)" type="checkbox" class="form-checkbox text-green w-6 h-6 rounded-full" :checked="isInLease(unit.id)">
                            </div>
                        </td>
                        <td class="text-center">{{ unit.floor }}</td>
                        <td class="text-center">{{ unit.suite }}</td>
                        <td class="text-right">{{ unit.size | number }}</td>
                        <td class="text-right">{{ unit.status }}</td>
                        <td class="text-center">{{ unit.updated_at | date }}</td>
                        <td>
                            <input 
                                v-model="unit.leased_square_footage"
                                type="text"
                                min="0"
                                :max="unit.size"
                                class="form-input w-full"
                                size="10"
                                @input="updateLeasedSquareFootage($event, unit.id)">
                        </td>
                    </tr>
                </paginate>
            </table>
            <paginate-links for="units" :show-step-links="true" :hide-single-page="true"></paginate-links>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
    	props: {
            perPage: {
                type: Number,
                default: 10
            }
        },
        
    	data() {
    		return {
                paginate: ['units'],
                loading: false
    		}
    	},

        computed: {
            ...mapState(['leases']),
            ...mapState(['sites']),

            buildingUnitData() {
                return this.sites.selectedSite.building.units;
            },

            units() {
                return _.map(this.buildingUnitData, (unit) => {
                    let isLeasedUnit = false;

                    if (this.leases.selectedLease) {
                        isLeasedUnit = _.find(this.leases.selectedLease.units, ['id', unit.id]);
                    }
                    
                    unit.leased_square_footage = isLeasedUnit
                        ? this.formatNumber(isLeasedUnit.pivot.leased_square_footage)
                        : '';
                    
                    return unit;
                });
            },
        },

        methods: {
            isInLease(unitId) {
                if (this.leases.selectedLease) {
                    return _.find(this.leases.selectedLease.units, ['id', unitId]);
                }

                return false;
            },

            toggleUnit(e, unitId) {
                let checked = e.target.checked;
                let unit = _.find(this.units, ['id', unitId]);

                if (unit && checked) {
                    unit.pivot = { leased_square_footage: unit.size };
                    unit.leased_square_footage = unit.size;

                    this.leases.selectedLease.units.push(unit);
                } else if (unit && ! checked) {
                    unit.pivot = { leased_square_footage: '' };
                    unit.leased_square_footage = '';

                    this.leases.selectedLease.units = _.remove(this.leases.selectedLease.units, (unit) => {
                        return unit.id != unitId;
                    });
                }

                this.$forceUpdate();
            },

            updateLeasedSquareFootage(e, unitId) {
                var unit = _.find(this.leases.selectedLease.units, ['id', unitId]);
                unit.pivot = { leased_square_footage: e.target.value };
                unit.leased_square_footage = e.target.value;          

                unit = _.find(this.units, ['id', unitId]);
                unit.leased_square_footage = e.target.value;
            }
        }
    }
</script>